import { render, staticRenderFns } from "./LicenseFilterTable.vue?vue&type=template&id=536a22da&scoped=true"
import script from "./LicenseFilterTable.vue?vue&type=script&lang=ts"
export * from "./LicenseFilterTable.vue?vue&type=script&lang=ts"
import style0 from "./LicenseFilterTable.vue?vue&type=style&index=0&id=536a22da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a22da",
  null
  
)

export default component.exports